// extracted by mini-css-extract-plugin
export var dividerLine = "_6c-3";
export var itemImage = "_6c-9";
export var lightDivider = "_6c-4";
export var modalContent = "_6c-5";
export var modalContentCompact = "_6c-6";
export var productCard = "_6c-a";
export var productImage = "_6c-b";
export var productImageCompact = "_6c-7";
export var productImagePlaceholder = "_6c-c";
export var productImagePlaceholderCompact = "_6c-8";
export var progressBarBackground = "_6c-1";
export var progressBarContainer = "_6c-0";
export var progressBarFill = "_6c-2";